export function isNullAddress(address: string) {
  return address === '0x'
}
